export default __webpack_public_path__ + "static/media/save_icon.d4c0f055.svg";